import { useEffect, useState } from "react";
import api from "../../../axiosConfig";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from "react-select";
import { popup } from "../../common/popup";

export default function LoanPage() {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [tools, setTools] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [kondisiKembali, setKondisiKembali] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [search, setSearch] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const openEditModal = (loan) => {
    setSelectedLoan(loan);
    setNewStatus(loan.status);
    setKondisiKembali(loan.kondisi_kembali || "");
    setEditModal(true);
  };

  useEffect(() => {
    api
      .get("/loan/barang-list")
      .then((res) => {
        const data = res.data;
        if (Array.isArray(data)) {
          setTools(data);
        } else if (Array.isArray(data?.data)) {
          setTools(data.data);
        } else {
          setTools([]);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    const loadData = async () => {
      await fetchLoans();
      setLoading(false);
    };

    loadData();
  }, []);

  const fetchLoans = async () => {
    try {
      const res = await api.get("/loan");
      const data = res.data;

      if (Array.isArray(data)) {
        setLoans(data);
      } else if (Array.isArray(data?.data)) {
        setLoans(data.data);
      } else {
        console.error("Format data salah:", data);
        setLoans([]);
      }
    } catch (err) {
      console.error(err);
      setLoans([]);
    }
  };

  const filteredLoans = Array.isArray(loans)
    ? loans.filter((loan) => {
        const keyword = search.toLowerCase();

        const matchSearch =
          loan.nama_barang?.toLowerCase().includes(keyword) ||
          loan.nama_peminjam?.toLowerCase().includes(keyword) ||
          loan.departemen?.toLowerCase().includes(keyword);

        const loanDate = new Date(loan.tanggal_pinjam);

        const matchStart = startDate ? loanDate >= new Date(startDate) : true;

        const matchEnd = endDate
          ? loanDate <= new Date(endDate + "T23:59:59")
          : true;

        return matchSearch && matchStart && matchEnd;
      })
    : [];

  const [form, setForm] = useState({
    tool_id: "",
    type: "",
    nama_peminjam: "",
    departemen: "",
    jumlah: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({
      ...form,
      [name]: name === "jumlah" ? Number(value) : value,
    });
  };

  const handleReturnSubmit = async () => {
    try {
      await api.put(`/loan/return/${selectedLoan.id}`, {
        status: newStatus,
        kondisi_kembali: newStatus === "dikembalikan" ? kondisiKembali : null,
      });

      popup.success(
        newStatus === "dikembalikan"
          ? "Barang berhasil dikembalikan"
          : "Data berhasil diperbarui",
      );

      setEditModal(false);
      setSelectedLoan(null);
      setKondisiKembali("");
      setNewStatus("");

      await fetchLoans();
    } catch (err) {
      console.error(err);
      popup.error("Gagal update status");
    }
  };

  const handleSubmit = async () => {
    if (submitting) return; // cegah double submit saat jaringan lag
    try {
      setSubmitting(true);
      await api.post("/loan", {
        ...form,
        status: "dipinjam",
      });

      popup.success("Peminjaman berhasil disimpan!");

      setShowModal(false);

      setForm({
        tool_id: "",
        type: "",
        nama_peminjam: "",
        departemen: "",
        jumlah: "",
      });

      await fetchLoans();
    } catch (err) {
      console.error(err);
      popup.error("Terjadi kesalahan!");
    } finally {
      setSubmitting(false);
    }
  };

  const getStatusBadge = (loan) => {
    if (loan.status?.toLowerCase() === "dipinjam") {
      return <span style={styles.borrowed}>Dipinjam</span>;
    }

    return <span style={styles.returned}>Dikembalikan</span>;
  };

  if (loading) return <p style={{ padding: 20 }}>Loading...</p>;

  const handleDownloadExcel = () => {
    const exportData = filteredLoans.map((loan, index) => ({
      No: index + 1,
      "Nama Barang": loan.nama_barang,
      Spec: loan.spec,
      Peminjam: loan.nama_peminjam,
      Departemen: loan.departemen,
      Jumlah: loan.jumlah,
      "Tanggal Pinjam": new Date(loan.tanggal_pinjam).toLocaleString("id-ID"),
      Status: loan.status,
      "Kondisi Kembali": loan.kondisi_kembali || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data Peminjaman");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(fileData, `Data_Peminjaman_${new Date().getTime()}.xlsx`);
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <Modal show={editModal} onHide={() => setEditModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit Status Peminjaman</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}
              >
                <option value="dipinjam">Dipinjam</option>
                <option value="dikembalikan">Dikembalikan</option>
              </Form.Select>
            </Form.Group>

            {newStatus === "dikembalikan" && (
              <Form.Group>
                <Form.Label>Kondisi Barang</Form.Label>
                <Form.Control
                  type="text"
                  value={kondisiKembali}
                  onChange={(e) => setKondisiKembali(e.target.value)}
                  placeholder="Contoh: Baik / Rusak Ringan"
                />
              </Form.Group>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setEditModal(false)}>
              Batal
            </Button>
            <Button variant="success" onClick={handleReturnSubmit}>
              Simpan
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Tambah Data Peminjaman</Modal.Title>
          </Modal.Header>
          {/* MODAL RETURN */}

          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Nama Barang</Form.Label>

                <Select
                  options={tools.map((tool) => ({
                    value: tool.id,
                    label: `${tool.nama} || ${tool.spec} || (${tool.stock_qty})`,
                    data: tool,
                  }))}
                  value={
                    tools
                      .map((tool) => ({
                        value: tool.id,
                        label: `${tool.nama} || ${tool.spec} || (${tool.stock_qty})`,
                        data: tool,
                      }))
                      .find((opt) => opt.value === form.tool_id) || null
                  }
                  onChange={(selectedOption) => {
                    if (!selectedOption) return;

                    setForm({
                      ...form,
                      tool_id: selectedOption.data.id,
                      type: selectedOption.data.type,
                    });
                  }}
                  placeholder="🔍 Cari dan pilih barang..."
                  isSearchable
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Nama Peminjam</Form.Label>
                <Form.Control
                  type="text"
                  name="nama_peminjam"
                  value={form.nama_peminjam}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Departemen</Form.Label>
                <Form.Control
                  type="text"
                  name="departemen"
                  value={form.departemen}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <div className="row">
                <div className="col">
                  <Form.Label>Jumlah</Form.Label>
                  <Form.Control
                    type="number"
                    name="jumlah"
                    value={form.jumlah}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Batal
            </Button>
            <Button variant="primary" onClick={handleSubmit} disabled={submitting}>
              {submitting ? "Menyimpan..." : "Simpan"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* HEADER TOP */}
        <div style={styles.headerTop}>
          <div>
            <h2 style={styles.title}>Data Peminjaman</h2>
          </div>

          <div style={styles.headerButtonGroup}>
            <button
              style={styles.openButton}
              onClick={() => setShowModal(true)}
              className="bg-primary"
            >
              + Tambah
            </button>
            <button style={styles.excelButton} onClick={handleDownloadExcel}>
              Export Excel
            </button>
          </div>
        </div>

        {/* HEADER FILTER */}
        <div style={styles.headerFilter}>
          <div style={styles.filterSection}>
            <div style={styles.filterGroup}>
              <label style={styles.filterLabel}>Dari</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                style={styles.dateInput}
              />
            </div>

            <div style={styles.filterGroup}>
              <label style={styles.filterLabel}>Sampai</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                style={styles.dateInput}
              />
            </div>

            <input
              type="text"
              placeholder="🔍 Cari..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={styles.searchInput}
            />

            <button
              className="bg-danger text-white"
              style={styles.resetButton}
              onClick={() => {
                setSearch("");
                setStartDate("");
                setEndDate("");
              }}
            >
              Reset
            </button>
          </div>
        </div>

        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th
                  style={{
                    ...styles.th,
                    backgroundColor: "#1e3a8a",
                    color: "#fff",
                    border: "1px solid #2747a1",
                    padding: "14px 12px",
                  }}
                >
                  No
                </th>
                <th
                  style={{
                    ...styles.th,
                    backgroundColor: "#1e3a8a",
                    color: "#fff",
                    border: "1px solid #2747a1",
                    padding: "14px 12px",
                  }}
                >
                  Nama Barang
                </th>
                <th
                  style={{
                    ...styles.th,
                    backgroundColor: "#1e3a8a",
                    color: "#fff",
                    border: "1px solid #2747a1",
                    padding: "14px 12px",
                  }}
                >
                  Kode / Spec
                </th>
                <th
                  style={{
                    ...styles.th,
                    backgroundColor: "#1e3a8a",
                    color: "#fff",
                    border: "1px solid #2747a1",
                    padding: "14px 12px",
                  }}
                >
                  Peminjam
                </th>
                <th
                  style={{
                    ...styles.th,
                    backgroundColor: "#1e3a8a",
                    color: "#fff",
                    border: "1px solid #2747a1",
                    padding: "14px 12px",
                  }}
                >
                  Departemen
                </th>
                <th
                  style={{
                    ...styles.th,
                    backgroundColor: "#1e3a8a",
                    color: "#fff",
                    border: "1px solid #2747a1",
                    padding: "14px 12px",
                  }}
                >
                  Jumlah
                </th>
                <th
                  style={{
                    ...styles.th,
                    backgroundColor: "#1e3a8a",
                    color: "#fff",
                    border: "1px solid #2747a1",
                    padding: "14px 12px",
                  }}
                >
                  Tanggal Pinjam
                </th>
                <th
                  style={{
                    ...styles.th,
                    backgroundColor: "#1e3a8a",
                    color: "#fff",
                    border: "1px solid #2747a1",
                    padding: "14px 12px",
                  }}
                >
                  Status
                </th>
                <th
                  style={{
                    ...styles.th,
                    backgroundColor: "#1e3a8a",
                    color: "#fff",
                    border: "1px solid #2747a1",
                    padding: "14px 12px",
                  }}
                >
                  Kondisi
                </th>
                <th
                  style={{
                    ...styles.th,
                    backgroundColor: "#1e3a8a",
                    color: "#fff",
                    border: "1px solid #2747a1",
                    padding: "14px 12px",
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {filteredLoans.length === 0 ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center", padding: 20 }}>
                    Tidak ada data
                  </td>
                </tr>
              ) : (
                filteredLoans.map((loan, index) => (
                  <tr key={loan.id}>
                    <td style={styles.td} className="text-center">
                      {index + 1}
                    </td>
                    <td style={styles.td}>{loan.nama_barang}</td>
                    <td style={styles.td}>({loan.spec})</td>
                    <td style={styles.td}>{loan.nama_peminjam}</td>
                    <td style={styles.td}>{loan.departemen}</td>
                    <td style={styles.td} className="text-center">
                      {loan.jumlah}
                    </td>
                    <td style={styles.td}>
                      {new Date(loan.tanggal_pinjam).toLocaleString("id-ID", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </td>

                    <td style={styles.td}>{getStatusBadge(loan)}</td>
                    <td style={styles.td}>{loan.kondisi_kembali || "-"}</td>

                    <td style={styles.td} className="text-center">
                      {loan.status?.toLowerCase() === "dipinjam" ? (
                        <button
                          style={styles.editButton}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor = "#1d4ed8")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor = "#2563eb")
                          }
                          onClick={() => openEditModal(loan)}
                        >
                          Edit Status
                        </button>
                      ) : (
                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            textAlign: "center",
                            backgroundColor: "#e6f9ec",
                            color: "#147538",
                            padding: "6px 12px",
                            borderRadius: "20px",
                          }}
                        >
                          Selesai
                        </span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLE ================= */

const styles = {
  page: {
    padding: "0",
    backgroundColor: "#f4f6f9",
    minHeight: "86vh",
    marginTop: "-10px",
  },
  leftHeader: {
    display: "flex",
    flexDirection: "column",
  },

  subtitle: {
    fontSize: "13px",
    color: "#6b7280",
    marginTop: "-10px",
  },

  filterSection: {
    display: "flex",
    alignItems: "flex-end",
    gap: "12px",
    flexWrap: "wrap",
  },

  filterGroup: {
    display: "flex",
    flexDirection: "column",
  },

  filterLabel: {
    fontSize: "12px",
    fontWeight: "600",
    marginBottom: "4px",
    color: "#374151",
  },

  resetButton: {
    padding: "8px 14px",
    backgroundColor: "#e5e7eb",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
  },

  headerButtonGroup: {
    display: "flex",
    gap: "12px", // jarak antar tombol
    alignItems: "center",
  },

  openButton: {
    padding: "8px 16px",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
  },

  excelButton: {
    padding: "8px 16px",
    backgroundColor: "#2f9c57",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
  },

  modal: {
    backgroundColor: "#ffffff",
    width: "600px",
    padding: "30px",
    borderRadius: "16px",
    boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
    animation: "fadeScale 0.2s ease",
  },

  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "25px",
    paddingBottom: "15px",
    borderBottom: "1px solid #e5e7eb",
  },

  formGridBetter: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
  },

  inputGroup: {
    display: "flex",
    flexDirection: "column",
  },

  label: {
    fontSize: "13px",
    fontWeight: "600",
    marginBottom: "6px",
    color: "#374151",
  },

  inputBetter: {
    padding: "12px 14px",
    borderRadius: "10px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
    outline: "none",
    transition: "all 0.2s ease",
  },

  editButton: {
    padding: "6px 14px",
    backgroundColor: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    transition: "all 0.2s ease",
  },

  editButtonHover: {
    backgroundColor: "#1d4ed8",
  },

  dateInput: {
    padding: "8px 10px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
  },

  saveButton: {
    padding: "10px 20px",
    backgroundColor: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "600",
    boxShadow: "0 6px 14px rgba(37,99,235,0.3)",
    transition: "0.2s",
  },

  cancelButton: {
    padding: "10px 16px",
    backgroundColor: "#6b7280",
    color: "white",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
  },

  card: {
    backgroundColor: "white",
    padding: "15px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  },

  headerTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
  },

  headerFilter: {
    marginBottom: "20px",
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "-20px",
  },

  rightHeader: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },

  searchInput: {
    padding: "8px 14px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
    width: "200px",
  },

  title: {
    marginBottom: "20px",
  },

  th: {
    border: "1px solid #e5e7eb",
    padding: "12px",
    backgroundColor: "#f9fafb",
    textAlign: "left",
    fontWeight: "600",
    fontSize: "14px",
  },

  td: {
    border: "1px solid #e5e7eb",
    padding: "12px",
    fontSize: "14px",
  },

  borrowed: {
    backgroundColor: "#e6f0ff",
    color: "#1d4ed8",
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: "600",
  },

  returned: {
    backgroundColor: "#e6f9ec",
    color: "#15803d",
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: "600",
  },
  tableWrapper: {
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
  },

  table: {
    width: "100%",
    minWidth: "1000px",
    borderCollapse: "collapse",
  },
};
